var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9833 9.99896C12.9833 11.649 11.65 12.9823 10 12.9823C8.35 12.9823 7.01666 11.649 7.01666 9.99896C7.01666 8.34896 8.35 7.01562 10 7.01562C11.65 7.01562 12.9833 8.34896 12.9833 9.99896Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 16.8932C12.9417 16.8932 15.6833 15.1599 17.5917 12.1599C18.3417 10.9849 18.3417 9.0099 17.5917 7.8349C15.6833 4.8349 12.9417 3.10156 9.99999 3.10156C7.05833 3.10156 4.31666 4.8349 2.40833 7.8349C1.65833 9.0099 1.65833 10.9849 2.40833 12.1599C4.31666 15.1599 7.05833 16.8932 9.99999 16.8932Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.96cc3d2445eb7cfe01c89accf927f37f.svg";
export { ForwardRef as ReactComponent };